let currentStep = 1;
let hasCompleted = false;
let entryUrl = '';
let needsAttachFileReuploadNotice = false;
let latestStep4Data = null;
let hasShownRestoreFailureNotice = false;
const AS_SUBMIT_ENDPOINT = 'https://sidiz-shopify.sidiz.com/v2/as/asSaveReqInfo';
const API_LOG_ADD_ENDPOINT = 'https://sidiz-shopify.sidiz.com/api/log/add';
const AS_SERIAL_AVAILABILITY_ENDPOINT = 'https://sidiz-shopify.sidiz.com/v2/as/serial/availability';
const STEP2_MIN_SYMPTOM_LENGTH = 30;
const AS_REFRESH_STATE_KEY = 'asStepRefreshStateV1';
const AS_ENTRY_URL_KEY = 'asEntryUrl';
const AS_REFRESH_LEAVE_META_KEY = 'asStepLeaveMetaV1';
const AS_REFRESH_TARGET_STEPS = new Set([2, 3, 4]);
const AS_REFRESH_STATE_MAX_AGE_MS = 30 * 60 * 1000; // 30분
const AS_REFRESH_LEAVE_MATCH_WINDOW_MS = 15 * 1000; // 15초
const APPLICANT_PHONE1_REQUIRED_ERROR_MESSAGE = '휴대폰 번호를 작성해 주세요.';
const APPLICANT_PHONE1_FORMAT_ERROR_MESSAGE = '휴대폰 번호를 확인해 주세요.';
const APPLICANT_PHONE1_PATTERN = /^01\d-\d{4}-\d{4}$/;
const AS_NAME_DIGIT_PATTERN = /\d+/g;
const AS_REFRESH_FORM_FIELDS = [
  'serialNumber',
  'part',
  'part_name',
  'symptom',
  'symptom_name',
  'symptom_desc',
  'is_different',
  'buyer_name',
  'buyer_name_unknown',
  'purchase_date',
  'purchase_date_unknown',
  'purchase_channel',
  'purchase_channel_detail',
  'purchase_channel_unknown',
  'applicant_name',
  'applicant_relationship',
  'applicant_phone_1',
  'applicant_phone_2',
  'address_zonecode',
  'address_main',
  'address_detail',
  'address_detail_unknown',
  'visit_date',
  'confirm_checkbox'
];
let isSubmittingAsRequest = false;
let isCheckingSerialAvailability = false;

let formData = {
  // Step 1
  serialNumber: null,

  // Step 2
  part: '',
  part_name: '',
  symptom: '',
  symptom_name: '',
  symptom_desc: '',
  attach_file: [],

  // Step 3 - 구매 정보
  is_different: false,
  buyer_name: '',
  buyer_name_unknown: false,
  purchase_date: '',
  purchase_date_unknown: false,
  purchase_channel: '',
  purchase_channel_detail: '',
  purchase_channel_unknown: false,

  // Step 3 - 신청 정보
  applicant_name: '',
  applicant_relationship: '',
  applicant_phone_1: '',
  applicant_phone_2: '',
  address_zonecode: '',
  address_main: '',
  address_detail: '',
  address_detail_unknown: false,
  visit_date: '',
  confirm_checkbox: false
};

const STEP_4_DATA = {
  product_name: "T00",
  prodcut_code: "ABCDE123",
  color_code: "FG00",
  serialNumber: "0000-23CEQC-234R",
  part: "부위 1",
  symptom: "증상 1",
  attach_file: [],
  applicant_name: "신청자1",
  applicant_phone_1: "000-0000-0000",
  address_zonecode: "00000",
  address_main: "주소지 0",
  address_detail: "주소지 상세 00",
  visit_date: "0000.00.00",
}

window.formData = formData;

function isReloadNavigation() {
  if (window.performance && typeof window.performance.getEntriesByType === 'function') {
    const navEntries = window.performance.getEntriesByType('navigation');
    if (navEntries && navEntries[0] && navEntries[0].type) {
      return navEntries[0].type === 'reload';
    }
  } else if (window.performance && window.performance.navigation) {
    return window.performance.navigation.type === 1;
  }
  return false;
}

function getNavigationType() {
  if (window.performance && typeof window.performance.getEntriesByType === 'function') {
    const navEntries = window.performance.getEntriesByType('navigation');
    const navType = safeString(navEntries?.[0]?.type).toLowerCase();
    if (navType) return navType;
  }

  if (window.performance && window.performance.navigation) {
    const legacyType = window.performance.navigation.type;
    if (legacyType === 1) return 'reload';
    if (legacyType === 2) return 'back_forward';
    return 'navigate';
  }

  return '';
}

function getAsPageKey() {
  return `${window.location.pathname}${window.location.search}`;
}

function isSameAsPageReferrer() {
  const referrer = safeString(document.referrer);
  if (!referrer) return false;

  try {
    const refUrl = new URL(referrer);
    const currentUrl = new URL(window.location.href);
    return (
      refUrl.origin === currentUrl.origin
      && refUrl.pathname === currentUrl.pathname
      && refUrl.search === currentUrl.search
    );
  } catch (error) {
    return false;
  }
}

function readAsLeaveMeta() {
  try {
    const raw = sessionStorage.getItem(AS_REFRESH_LEAVE_META_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;

    const ts = Number(parsed.ts);
    if (!Number.isFinite(ts) || ts <= 0) return null;

    return {
      ts,
      pageKey: safeString(parsed.pageKey),
      reason: safeString(parsed.reason)
    };
  } catch (error) {
    return null;
  }
}

function persistAsLeaveMeta(reason = 'leave') {
  try {
    const payload = {
      ts: Date.now(),
      pageKey: getAsPageKey(),
      reason: safeString(reason),
      referrer: safeString(document.referrer)
    };
    sessionStorage.setItem(AS_REFRESH_LEAVE_META_KEY, JSON.stringify(payload));
  } catch (error) {
    // ignore storage errors
  }
}

function hasRecentRefreshSnapshot(updatedAt) {
  const ts = Number(updatedAt);
  if (!Number.isFinite(ts) || ts <= 0) return false;
  return (Date.now() - ts) <= AS_REFRESH_STATE_MAX_AGE_MS;
}

function hasRecentSamePageLeave() {
  const leaveMeta = readAsLeaveMeta();
  if (!leaveMeta) return false;
  if (leaveMeta.pageKey !== getAsPageKey()) return false;
  return (Date.now() - leaveMeta.ts) <= AS_REFRESH_LEAVE_MATCH_WINDOW_MS;
}

function shouldRestoreAsRefreshState(savedState) {
  if (!savedState || !AS_REFRESH_TARGET_STEPS.has(savedState.step)) return false;
  if (!hasRecentRefreshSnapshot(savedState.updatedAt)) return false;

  const navigationType = getNavigationType();
  const hasReferrerSignal = isSameAsPageReferrer();
  const hasRecentLeaveSignal = hasRecentSamePageLeave();

  // 기본: 명확한 새로고침 시그널
  if (navigationType === 'reload') return true;

  // back/forward 진입은 히스토리 상태를 우선 사용하고 스냅샷 자동 복원을 하지 않는다.
  if (navigationType === 'back_forward') return false;

  // 모바일(iOS/Android) 일부 브라우저의 navigation type 누락/불일치 보완
  // referrer + 최근 같은 페이지 이탈 시그널이 모두 있을 때만 복원한다.
  if (hasReferrerSignal && hasRecentLeaveSignal) return true;

  return false;
}

function shouldClearAsRefreshStateOnEntry(savedState) {
  if (!savedState) return true;

  if (!hasRecentRefreshSnapshot(savedState.updatedAt)) {
    return true;
  }

  const navigationType = getNavigationType();
  if (navigationType === 'reload') {
    return false;
  }

  // back/forward는 히스토리 상태를 기준으로 동작하므로 스냅샷은 제거한다.
  if (navigationType === 'back_forward') {
    return true;
  }

  if (navigationType === 'navigate') {
    return !isSameAsPageReferrer();
  }

  // navigation type 판단이 불가능한 경우는 복원 근거가 충분할 때만 유지한다.
  return !(isSameAsPageReferrer() && hasRecentSamePageLeave());
}

function clearAsRefreshState() {
  try {
    sessionStorage.removeItem(AS_REFRESH_STATE_KEY);
  } catch (error) {
    // ignore storage errors
  }
}

function clearAsEntryUrl() {
  try {
    sessionStorage.removeItem(AS_ENTRY_URL_KEY);
  } catch (error) {
    // ignore storage errors
  }
}

function sanitizeStep4DataForRefresh(data) {
  if (!data || typeof data !== 'object') return null;

  return {
    rptNo: safeString(data.rptNo),
    product_name: safeString(data.product_name),
    prodcut_code: safeString(data.prodcut_code),
    color_code: safeString(data.color_code),
    serialNumber: safeString(data.serialNumber),
    part: safeString(data.part),
    symptom: safeString(data.symptom),
    attach_file: [],
    applicant_name: safeString(data.applicant_name),
    applicant_phone_1: safeString(data.applicant_phone_1),
    address_zonecode: safeString(data.address_zonecode),
    address_main: safeString(data.address_main),
    address_detail: safeString(data.address_detail),
    visit_date: safeString(data.visit_date)
  };
}

function hasStep4RefreshData(step4Data) {
  if (!step4Data || typeof step4Data !== 'object') return false;
  const requiredSome = [
    safeString(step4Data.rptNo),
    safeString(step4Data.serialNumber),
    safeString(step4Data.applicant_name),
    safeString(step4Data.part),
    safeString(step4Data.symptom)
  ];
  return requiredSome.some(Boolean);
}

function readAsRefreshState() {
  try {
    const raw = sessionStorage.getItem(AS_REFRESH_STATE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;

    const step = normalizeStep(parsed.step);
    if (!AS_REFRESH_TARGET_STEPS.has(step)) return null;

    const savedPageKey = safeString(parsed.pageKey);
    const currentPageKey = getAsPageKey();
    if (savedPageKey && savedPageKey !== currentPageKey) return null;

    const savedEntryUrl = safeString(parsed.entryUrl);
    const updatedAt = Number(parsed.updatedAt);
    const savedUpdatedAt = Number.isFinite(updatedAt) ? updatedAt : 0;
    const savedReferrer = safeString(parsed.referrer);

    if (step === 4) {
      const step4Data = sanitizeStep4DataForRefresh(parsed.step4Data);
      if (!hasStep4RefreshData(step4Data)) return null;
      return {
        step,
        step4Data,
        entryUrl: savedEntryUrl,
        updatedAt: savedUpdatedAt,
        referrer: savedReferrer
      };
    }

    const savedFormData = parsed.formData && typeof parsed.formData === 'object'
      ? parsed.formData
      : {};

    const hadAttachFiles = Boolean(parsed.hadAttachFiles);
    return {
      step,
      formData: savedFormData,
      hadAttachFiles,
      entryUrl: savedEntryUrl,
      updatedAt: savedUpdatedAt,
      referrer: savedReferrer
    };
  } catch (error) {
    return null;
  }
}

function buildRefreshFormDataSnapshot() {
  const snapshot = {};
  AS_REFRESH_FORM_FIELDS.forEach((field) => {
    snapshot[field] = formData[field];
  });
  return snapshot;
}

function syncCurrentStepDataForRefresh() {
  if (currentStep === 2) {
    saveStep2Data();
  } else if (currentStep === 3) {
    saveStep3Data();
  }
}

function persistAsRefreshState() {
  if (!AS_REFRESH_TARGET_STEPS.has(currentStep)) {
    clearAsRefreshState();
    return;
  }

  if (currentStep === 2 || currentStep === 3) {
    syncCurrentStepDataForRefresh();
  }

  const payload = {
    step: currentStep,
    entryUrl: safeString(entryUrl),
    pageKey: getAsPageKey(),
    referrer: safeString(document.referrer),
    updatedAt: Date.now()
  };

  if (currentStep === 4) {
    const step4Data = sanitizeStep4DataForRefresh(latestStep4Data);
    if (!hasStep4RefreshData(step4Data)) {
      clearAsRefreshState();
      return;
    }
    payload.step4Data = step4Data;
  } else {
    payload.formData = buildRefreshFormDataSnapshot();
    payload.hadAttachFiles = Array.isArray(formData.attach_file) && formData.attach_file.length > 0;
  }

  try {
    sessionStorage.setItem(AS_REFRESH_STATE_KEY, JSON.stringify(payload));
  } catch (error) {
    // ignore storage errors
  }
}

function hasSelectOption(selectEl, targetValue) {
  if (!selectEl || !targetValue) return false;
  return Array.from(selectEl.options || []).some((option) => option.value === targetValue);
}

function tryRenderRegisteredProductPageForSerial(serialNumber) {
  const serial = safeString(serialNumber);
  if (!serial) return false;
  if (typeof renderRegisteredProductPage !== 'function') return false;

  let targetPage = null;

  if (typeof resolveRegisteredProductPageBySerial === 'function') {
    const resolvedPage = Number(resolveRegisteredProductPageBySerial(serial));
    if (Number.isFinite(resolvedPage) && resolvedPage > 0) {
      targetPage = resolvedPage;
    }
  }

  if (
    !targetPage
    && typeof registeredProductData !== 'undefined'
    && Array.isArray(registeredProductData)
    && registeredProductData.length > 0
  ) {
    const index = registeredProductData.findIndex((item) => safeString(item?.serialNumber) === serial);
    if (index >= 0) {
      const pageSize = Number(ITEMS_PER_PAGE) > 0 ? Number(ITEMS_PER_PAGE) : 1;
      targetPage = Math.floor(index / pageSize) + 1;
    }
  }

  if (!targetPage) return false;

  if (typeof currentRegisteredPage !== 'undefined' && currentRegisteredPage === targetPage) {
    return false;
  }

  if (typeof currentRegisteredPage !== 'undefined') {
    currentRegisteredPage = targetPage;
  }

  Promise.resolve(renderRegisteredProductPage(targetPage))
    .then(() => {
      if (typeof renderRegisteredProductPagination === 'function') {
        renderRegisteredProductPagination();
      }
    })
    .catch((error) => {
      console.error('[AS] 제품 복원 페이지 렌더 실패:', error);
    });

  return true;
}

function notifyRestoreFailureOnce(message) {
  const text = safeString(message);
  if (!text || hasShownRestoreFailureNotice) return;
  hasShownRestoreFailureNotice = true;
  openAsStepNoticeModal(text);
}

function restoreStep1UI(savedFormData, attempt = 0) {
  const serialNumber = safeString(savedFormData?.serialNumber);
  if (!serialNumber) return;

  const radios = Array.from(document.querySelectorAll('#as-form-1 input[name="selectProduct"]'));
  const matchedRadio = radios.find((radio) => safeString(radio.value) === serialNumber);
  const canRetry = attempt < 120;

  if (!matchedRadio) {
    const hasRequestedPageRender = tryRenderRegisteredProductPageForSerial(serialNumber);
    const listLoaded = typeof hasRegisteredProductListLoaded !== 'undefined'
      ? Boolean(hasRegisteredProductListLoaded)
      : false;

    if (canRetry) {
      setTimeout(() => restoreStep1UI(savedFormData, attempt + 1), 150);
      return;
    }

    // 제품 목록 로딩이 지연됐거나 페이지 렌더를 유도한 경우에는
    // 불필요한 오탐 모달을 띄우지 않고 다음 이벤트 루프에서 재동기화한다.
    if (!listLoaded || hasRequestedPageRender) {
      return;
    }

    updateFormData('serialNumber', '');
    notifyRestoreFailureOnce('저장된 제품 선택 정보를 복원하지 못했습니다. 제품을 다시 선택해 주세요.');
    if (typeof checkNextButtonState === 'function') {
      checkNextButtonState(1);
    }
    return;
  }

  matchedRadio.checked = true;
  const selectedCard = matchedRadio.closest('.wrap__my_product');
  if (selectedCard) {
    document.querySelectorAll('.wrap__my_product').forEach((card) => card.classList.remove('active'));
    selectedCard.classList.add('active');
  }

  updateFormData('serialNumber', serialNumber);
  if (typeof checkNextButtonState === 'function') {
    checkNextButtonState(1);
  }
}

function clearRestoredStep2Selection(type) {
  const partSelect = document.querySelector('#as-form-2 .as-symptom .select-part');
  const symptomSelect = document.querySelector('#as-form-2 .as-symptom .select-symptom');
  const textarea = document.querySelector('#as-form-2 .box-text textarea');

  if (type === 'part') {
    updateFormData('part', '');
    updateFormData('part_name', '');
    updateFormData('symptom', '');
    updateFormData('symptom_name', '');

    if (partSelect) {
      partSelect.value = '';
      partSelect.style.color = '#A4AAB0';
    }
    if (symptomSelect) {
      symptomSelect.disabled = true;
      symptomSelect.innerHTML = '<option value="" disabled selected hidden>옵션 선택</option>';
      symptomSelect.style.color = '#A4AAB0';
    }
  }

  if (type === 'symptom') {
    updateFormData('symptom', '');
    updateFormData('symptom_name', '');

    if (symptomSelect) {
      symptomSelect.value = '';
      symptomSelect.style.color = '#A4AAB0';
    }
  }

  if (type === 'symptom_desc') {
    updateFormData('symptom_desc', '');
    if (textarea) {
      textarea.value = '';
      textarea.dispatchEvent(new Event('blur', { bubbles: true }));
    }
  }

  if (typeof checkNextButtonState === 'function') {
    checkNextButtonState(2);
  }
}

function restoreStep2UI(savedFormData, attempt = 0) {
  const partSelect = document.querySelector('#as-form-2 .as-symptom .select-part');
  const symptomSelect = document.querySelector('#as-form-2 .as-symptom .select-symptom');
  const textarea = document.querySelector('#as-form-2 .box-text textarea');

  const partValue = String(savedFormData?.part || '').trim();
  const symptomValue = String(savedFormData?.symptom || '').trim();
  const symptomDescValue = String(savedFormData?.symptom_desc || '');
  const canRetry = attempt < 60;

  if (partValue && !partSelect) {
    if (canRetry) {
      setTimeout(() => restoreStep2UI(savedFormData, attempt + 1), 150);
      return;
    }
    clearRestoredStep2Selection('part');
    notifyRestoreFailureOnce('저장된 부위/증상 항목을 복원하지 못해 초기화했습니다. 다시 선택해 주세요.');
    return;
  }

  if (partValue && partSelect && !hasSelectOption(partSelect, partValue)) {
    if (canRetry) {
      setTimeout(() => restoreStep2UI(savedFormData, attempt + 1), 150);
      return;
    }
    clearRestoredStep2Selection('part');
    notifyRestoreFailureOnce('저장된 부위/증상 항목을 복원하지 못해 초기화했습니다. 다시 선택해 주세요.');
    return;
  }

  if (partSelect && partValue) {
    partSelect.value = partValue;
    partSelect.style.color = '#000';
    updateFormData('part', partValue);
    updateFormData('part_name', String(savedFormData?.part_name || partValue));
  }

  if (symptomValue && !symptomSelect) {
    if (canRetry) {
      setTimeout(() => restoreStep2UI(savedFormData, attempt + 1), 150);
      return;
    }
    clearRestoredStep2Selection('symptom');
    notifyRestoreFailureOnce('저장된 증상 항목을 복원하지 못해 초기화했습니다. 다시 선택해 주세요.');
    return;
  }

  if (symptomSelect && partValue) {
    symptomSelect.disabled = false;
    if (typeof updateSymptomOptions === 'function') {
      updateSymptomOptions(symptomSelect, partValue);
    }

    if (symptomValue && !hasSelectOption(symptomSelect, symptomValue)) {
      if (canRetry) {
        setTimeout(() => restoreStep2UI(savedFormData, attempt + 1), 150);
        return;
      }
      clearRestoredStep2Selection('symptom');
      notifyRestoreFailureOnce('저장된 증상 항목을 복원하지 못해 초기화했습니다. 다시 선택해 주세요.');
      return;
    }

    if (symptomValue) {
      symptomSelect.value = symptomValue;
      symptomSelect.style.color = '#000';
      updateFormData('symptom', symptomValue);
      updateFormData('symptom_name', String(savedFormData?.symptom_name || symptomValue));
    }
  }

  if (symptomDescValue && !textarea) {
    if (canRetry) {
      setTimeout(() => restoreStep2UI(savedFormData, attempt + 1), 150);
      return;
    }
    clearRestoredStep2Selection('symptom_desc');
    notifyRestoreFailureOnce('저장된 상세 증상 입력을 복원하지 못해 초기화했습니다. 다시 입력해 주세요.');
    return;
  }

  if (textarea) {
    if (symptomDescValue) {
      textarea.value = symptomDescValue;
      textarea.classList.remove('textarea-template-hint');
      textarea.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      textarea.dispatchEvent(new Event('blur', { bubbles: true }));
    }
  }

  if (typeof refreshStep2FaqLinks === 'function') {
    refreshStep2FaqLinks();
  }
}

function setFormFieldValue(form, selector, value, eventType = null) {
  const el = form?.querySelector(selector);
  if (!el) return;
  el.value = value;
  if (eventType) {
    el.dispatchEvent(new Event(eventType, { bubbles: true }));
  }
}

function setFormFieldChecked(form, selector, checked, eventType = null) {
  const el = form?.querySelector(selector);
  if (!el) return;
  el.checked = checked;
  if (eventType) {
    el.dispatchEvent(new Event(eventType, { bubbles: true }));
  }
}

function sanitizeAsNameText(value) {
  if (value === null || value === undefined) return '';
  return String(value).replace(AS_NAME_DIGIT_PATTERN, '');
}

function sanitizeAsNameInputElement(input) {
  if (!input) return '';

  const rawValue = input.value || '';
  const sanitizedValue = sanitizeAsNameText(rawValue);
  if (rawValue !== sanitizedValue) {
    input.value = sanitizedValue;
  }

  return sanitizedValue;
}

function getSanitizedAsNameValue(form, selector) {
  return sanitizeAsNameInputElement(form?.querySelector(selector)).trim();
}

function initializeAsNameInputs() {
  [
    { selector: '#applicant_name', field: 'applicant_name', errorSelector: '#applicant_name_error' },
    { selector: '#buyer_name', field: 'buyer_name' }
  ].forEach(({ selector, field, errorSelector }) => {
    const input = document.querySelector(selector);
    if (!input) return;

    sanitizeAsNameInputElement(input);

    input.addEventListener('input', () => {
      const sanitizedValue = sanitizeAsNameInputElement(input);
      updateFormData(field, sanitizedValue);

      if (errorSelector && sanitizedValue.trim() !== '') {
        document.querySelector(errorSelector)?.classList.add('hidden');
      }
    });
  });
}

function applyAddressDetailUnknownUIState(form, checked) {
  const detailInput = form?.querySelector('#address_detail');
  if (!detailInput) return;

  if (checked) {
    detailInput.value = '';
    detailInput.disabled = true;
    updateFormData('address_detail_unknown', true);
    updateFormData('address_detail', '');
    return;
  }

  detailInput.disabled = false;
  updateFormData('address_detail_unknown', false);
}

function restoreStep3UI(savedFormData) {
  const form3 = document.querySelector('#as-form-3');
  if (!form3) return;
  const restoredVisitDate = String(savedFormData?.visit_date || '');

  const relationshipValue = String(savedFormData?.applicant_relationship || '본인');
  setFormFieldValue(form3, '#applicant_relationship', relationshipValue, 'change');

  setFormFieldValue(form3, '#applicant_name', String(savedFormData?.applicant_name || ''), 'input');
  setFormFieldValue(form3, '#applicant_phone_1', String(savedFormData?.applicant_phone_1 || ''), 'input');
  setFormFieldValue(form3, '#applicant_phone_2', String(savedFormData?.applicant_phone_2 || ''), 'input');

  setFormFieldChecked(form3, '#buyer_name_unknown', Boolean(savedFormData?.buyer_name_unknown), 'change');
  if (!savedFormData?.buyer_name_unknown) {
    setFormFieldValue(form3, '#buyer_name', String(savedFormData?.buyer_name || ''), 'input');
  }

  setFormFieldChecked(form3, '#purchase_date_unknown', Boolean(savedFormData?.purchase_date_unknown), 'change');
  if (!savedFormData?.purchase_date_unknown) {
    setFormFieldValue(form3, '#purchase_date', String(savedFormData?.purchase_date || ''), 'change');
  }

  setFormFieldChecked(form3, '#purchase_channel_unknown', Boolean(savedFormData?.purchase_channel_unknown), 'change');
  if (!savedFormData?.purchase_channel_unknown) {
    setFormFieldValue(form3, '#purchase_channel', String(savedFormData?.purchase_channel || ''), 'change');
    setFormFieldValue(form3, '#purchase_channel_detail', String(savedFormData?.purchase_channel_detail || ''), 'input');
  }

  setFormFieldValue(form3, '#address_zonecode', String(savedFormData?.address_zonecode || ''));
  setFormFieldValue(form3, '#address_main', String(savedFormData?.address_main || ''));
  const addressDetailUnknown = Boolean(savedFormData?.address_detail_unknown);
  setFormFieldChecked(form3, '#address_detail_unknown', addressDetailUnknown);
  applyAddressDetailUnknownUIState(form3, addressDetailUnknown);
  if (!addressDetailUnknown) {
    setFormFieldValue(form3, '#address_detail', String(savedFormData?.address_detail || ''), 'input');
  }

  const applyVisitDateValue = () => {
    setFormFieldValue(form3, '#visit_date', restoredVisitDate, 'change');
    if (typeof checkNextButtonState === 'function') {
      checkNextButtonState(3);
    }
  };

  if (typeof syncVisitDateVisibility === 'function') {
    syncVisitDateVisibility();
  }

  const hasAddress =
    safeString(savedFormData?.address_zonecode) !== ''
    && safeString(savedFormData?.address_main) !== '';

  if (hasAddress && typeof refreshAvailableVisitDates === 'function') {
    Promise.resolve(refreshAvailableVisitDates())
      .catch((error) => {
        console.error('희망 방문일 복원용 재조회 실패:', error);
      })
      .finally(() => {
        applyVisitDateValue();
      });
  } else {
    applyVisitDateValue();
  }

  setFormFieldChecked(form3, '#confirm_checkbox', Boolean(savedFormData?.confirm_checkbox), 'change');
}

function restoreAsRefreshStateToUI(savedState) {
  if (!savedState || !AS_REFRESH_TARGET_STEPS.has(savedState.step)) return;

  if (savedState.step === 2) {
    restoreStep1UI(savedState.formData);
    restoreStep2UI(savedState.formData);
    const hasStep3Snapshot =
      safeString(savedState.formData?.applicant_name) !== ''
      || safeString(savedState.formData?.applicant_phone_1) !== ''
      || safeString(savedState.formData?.address_zonecode) !== ''
      || safeString(savedState.formData?.address_main) !== ''
      || safeString(savedState.formData?.address_detail) !== ''
      || Boolean(savedState.formData?.address_detail_unknown)
      || safeString(savedState.formData?.visit_date) !== ''
      || safeString(savedState.formData?.purchase_date) !== ''
      || safeString(savedState.formData?.purchase_channel) !== ''
      || safeString(savedState.formData?.purchase_channel_detail) !== ''
      || safeString(savedState.formData?.buyer_name) !== ''
      || Boolean(savedState.formData?.confirm_checkbox);

    // 2단계 복원이라도 3단계 입력 스냅샷이 있으면 같이 복원해
    // 주소 기반 희망 방문일 API 조회가 재실행되도록 맞춘다.
    if (hasStep3Snapshot) {
      restoreStep3UI(savedState.formData);
    }

    if (typeof checkNextButtonState === 'function') {
      checkNextButtonState(2);
    }
    return;
  }

  if (savedState.step === 3) {
    restoreStep1UI(savedState.formData);
    // 3단계에서 새로고침 복원된 경우에도,
    // 뒤로가기로 2단계 이동 시 이전 입력값이 유지되도록 2단계 UI를 같이 복원한다.
    restoreStep2UI(savedState.formData);
    restoreStep3UI(savedState.formData);
    return;
  }

  if (savedState.step === 4) {
    const step4Data = sanitizeStep4DataForRefresh(savedState.step4Data);
    if (!hasStep4RefreshData(step4Data)) return;
    latestStep4Data = step4Data;
    renderData(step4Data);
  }
}

function notifyAttachFileReuploadIfNeeded(step) {
  if (step !== 2 || !needsAttachFileReuploadNotice) return;
  needsAttachFileReuploadNotice = false;

  if (typeof checkNextButtonState === 'function') {
    checkNextButtonState(2);
  }

  openAsStepNoticeModal('새로고침으로 인해 첨부한 사진/영상은 자동으로 복원되지 않습니다.\n번거로우시겠지만 파일만 다시 첨부해 주시기 바랍니다.');
}

function getStep2MinSymptomLength() {
  const fromWindow = Number(window?.AS_MIN_SYMPTOM_LENGTH);
  if (Number.isFinite(fromWindow) && fromWindow > 0) {
    return fromWindow;
  }
  return STEP2_MIN_SYMPTOM_LENGTH;
}

function getStep2SymptomDescLength(value) {
  if (typeof window?.getAsSymptomUserInputLength === 'function') {
    return window.getAsSymptomUserInputLength(value);
  }

  return String(value || '').trim().length;
}

function isStep2SymptomDescValid(value) {
  return getStep2SymptomDescLength(value) >= getStep2MinSymptomLength();
}

function validateApplicantPhone1(value) {
  const applicantPhone1 = safeString(value).trim();

  if (!applicantPhone1) {
    return {
      isValid: false,
      message: APPLICANT_PHONE1_REQUIRED_ERROR_MESSAGE
    };
  }

  if (!APPLICANT_PHONE1_PATTERN.test(applicantPhone1)) {
    return {
      isValid: false,
      message: APPLICANT_PHONE1_FORMAT_ERROR_MESSAGE
    };
  }

  return {
    isValid: true,
    message: ''
  };
}

function isAsCommonCode(value) {
  return /^AA\d{4}$/i.test(safeString(value));
}

function hasStep2AttachedFiles() {
  return Array.isArray(formData.attach_file) && formData.attach_file.length > 0;
}

function isStep1ProgressReady() {
  if (safeString(formData.serialNumber)) return true;

  const selectedRadio = document.querySelector('#as-form-1 input[name="selectProduct"]:checked');
  const selectedSerial = safeString(selectedRadio?.value);
  if (!selectedSerial) return false;

  updateFormData('serialNumber', selectedSerial);
  return true;
}

function isStep2ProgressReady() {
  const hasPart = isAsCommonCode(formData.part);
  const hasSymptom = isAsCommonCode(formData.symptom);
  const hasSymptomDesc = isStep2SymptomDescValid(formData.symptom_desc);
  const hasFile = hasStep2AttachedFiles();

  return hasPart && hasSymptom && hasSymptomDesc && hasFile;
}

function openAsStepNoticeModal(message) {
  const text = safeString(message);
  if (!text) return;

  if (typeof openMiniModalWithContent === 'function' && typeof closeMiniModal === 'function') {
    const content = `
      <div class="mini-modal-center">
        <div class="mini-modal-text">${escapeHtml(text).replace(/\n/g, '<br>')}</div>
        <div class="mini-modal-btn">확인</div>
      </div>
    `;

    openMiniModalWithContent(content, () => {
      const closeBtn = document.querySelector('#site-mini-modal .mini-modal-btn');
      closeBtn?.addEventListener('click', closeMiniModal, { once: true });
    });
    return;
  }

  if (
    typeof setPopupModal === 'function'
    && typeof showPopupModal === 'function'
    && typeof closePopupModal === 'function'
  ) {
    const content = `
      <div class="mini-modal-center">
        <div class="mini-modal-text">${escapeHtml(text).replace(/\n/g, '<br>')}</div>
        <div class="mini-modal-btn">확인</div>
      </div>
    `;
    setPopupModal(content);
    showPopupModal();

    const closeBtn = document.querySelector('#main-popup-modal .mini-modal-btn');
    closeBtn?.addEventListener('click', closePopupModal, { once: true });
    return;
  }

  console.error('[AS] notice modal functions are unavailable:', text);
}

function openAsProductNotSelectedModal() {
  const title = '제품을 선택해 주세요.';
  const content = `
    <div class="mini-modal-center as-serial-in-progress-modal">
      <div class="as-serial-in-progress-title">${escapeHtml(title)}</div>
      <div class="mini-modal-btn">확인</div>
    </div>
  `;

  if (typeof openMiniModalWithContent === 'function' && typeof closeMiniModal === 'function') {
    openMiniModalWithContent(content, () => {
      const closeBtn = document.querySelector('#site-mini-modal .mini-modal-btn');
      closeBtn?.addEventListener('click', closeMiniModal, { once: true });
    });
    return;
  }

  if (
    typeof setPopupModal === 'function'
    && typeof showPopupModal === 'function'
    && typeof closePopupModal === 'function'
  ) {
    setPopupModal(content);
    showPopupModal();
    const closeBtn = document.querySelector('#main-popup-modal .mini-modal-btn');
    closeBtn?.addEventListener('click', closePopupModal, { once: true });
    return;
  }

  openAsStepNoticeModal(title);
}

function openAsSerialInProgressModal() {
  const title = '이미 접수된 AS가 있는 제품입니다.';
  const description = '해당 제품은 현재 AS가 진행 중입니다.\n처리 완료 후 다시 접수해 주세요.';
  const content = `
    <div class="mini-modal-center as-serial-in-progress-modal">
      <div class="as-serial-in-progress-title">${escapeHtml(title)}</div>
      <div class="as-serial-in-progress-desc">${escapeHtml(description).replace(/\n/g, '<br>')}</div>
      <div class="mini-modal-btn">확인</div>
    </div>
  `;

  if (typeof openMiniModalWithContent === 'function' && typeof closeMiniModal === 'function') {
    openMiniModalWithContent(content, () => {
      const closeBtn = document.querySelector('#site-mini-modal .mini-modal-btn');
      closeBtn?.addEventListener('click', closeMiniModal, { once: true });
    });
    return;
  }

  if (
    typeof setPopupModal === 'function'
    && typeof showPopupModal === 'function'
    && typeof closePopupModal === 'function'
  ) {
    setPopupModal(content);
    showPopupModal();

    const closeBtn = document.querySelector('#main-popup-modal .mini-modal-btn');
    closeBtn?.addEventListener('click', closePopupModal, { once: true });
    return;
  }

  openAsStepNoticeModal(`${title}\n${description}`);
}

function resolveAsSerialAvailabilityErrorMessage(responseBody, status) {
  const msg = safeString(responseBody?.msg || responseBody?.message);
  if (msg) return msg;

  if (status === 400) {
    return '시리얼 번호 확인에 필요한 정보가 누락되었습니다.';
  }
  if (status >= 500) {
    return '신청 가능 여부를 확인하는 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
  }
  return 'AS 신청 가능 여부를 확인하지 못했습니다.';
}

async function checkAsSerialAvailability(serialNm) {
  const serial = safeString(serialNm);
  if (!serial) {
    return {
      canProceed: false,
      message: '제품을 선택한 뒤 다시 시도해 주세요.'
    };
  }

  let responseBody = null;
  let responseStatus = 0;

  try {
    const response = await fetch(AS_SERIAL_AVAILABILITY_ENDPOINT, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ serialNm: serial })
    });

    responseStatus = response.status;
    try {
      responseBody = await response.json();
    } catch (error) {
      responseBody = null;
    }

    if (!response.ok) {
      return {
        canProceed: false,
        message: resolveAsSerialAvailabilityErrorMessage(responseBody, responseStatus)
      };
    }

    const isSuccess = responseBody?.success === true;
    const canApply = responseBody?.canApply === true;
    const code = safeString(responseBody?.code);
    const reason = safeString(responseBody?.reason).toUpperCase();
    const isInProgress = code === '2001' || reason === 'IN_PROGRESS';

    if (isSuccess && canApply) {
      return { canProceed: true };
    }

    return {
      canProceed: false,
      isInProgress,
      message: resolveAsSerialAvailabilityErrorMessage(responseBody, responseStatus)
    };
  } catch (error) {
    return {
      canProceed: false,
      message: '신청 가능 여부를 확인하는 중 네트워크 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.'
    };
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  initializeAsNameInputs();
  initializeNextButtons(); // 다음 버튼 이벤트 연결
  initStepHistory();

  window.addEventListener('beforeunload', () => {
    persistAsRefreshState();
    persistAsLeaveMeta('beforeunload');
  });

  window.addEventListener('pagehide', () => {
    persistAsRefreshState();
    persistAsLeaveMeta('pagehide');
  });

  try {
    await Promise.all([
      // 제품 데이터 로드 대기
      (typeof allProductDataLoaded !== "undefined") ? allProductDataLoaded : Promise.resolve(),
      // 리페어 데이터 로드 대기
      (typeof easyRepairDataLoaded !== "undefined") ? easyRepairDataLoaded : Promise.resolve()
    ]);
  }
  catch (error) {
    console.error("🚨 데이터 로딩 중 오류 발생:", error);
  }

  /* 1. 제품 선택 */
  // 나의 등록 제품 조회
  fetchMyRegisteredProduct()
    .then((data) => {
      showRegisteredProduct(data);
    })
    .catch((error) => {
      console.error(error);
      showRegisteredProduct([]);
    })

  // 제품 등록 버튼 이벤트 연결
  let btnAddProduct = document.querySelectorAll('#as-form-1 .btn_add_product');
  btnAddProduct.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      button.blur();
      openProductRegisterModal();
    });
  });
});

function normalizeStep(stepNumber) {
  const parsed = parseInt(stepNumber, 10);
  if (!Number.isFinite(parsed)) return 1;
  return Math.min(Math.max(parsed, 1), 4);
}

function resolveEntryUrl() {
  const fallbackLink = document.querySelector('#as-form-4 .as-move-btn')?.getAttribute('href') || '/';
  let fallbackUrl = '/';
  try {
    fallbackUrl = new URL(fallbackLink, window.location.origin).toString();
  } catch (error) {
    fallbackUrl = fallbackLink || '/';
  }

  const referrer = document.referrer;
  if (referrer && referrer !== window.location.href) {
    try {
      const refUrl = new URL(referrer);
      const currentUrl = new URL(window.location.href);
      const isSameAsPath =
        refUrl.origin === currentUrl.origin
        && refUrl.pathname === currentUrl.pathname
        && refUrl.search === currentUrl.search;

      if (refUrl.origin === window.location.origin && !isSameAsPath) {
        const refValue = refUrl.toString();
        try {
          sessionStorage.setItem(AS_ENTRY_URL_KEY, refValue);
        } catch (error) {
          // ignore storage errors
        }
        return refValue;
      }
    } catch (error) {
      // ignore invalid referrer
    }
  }

  try {
    sessionStorage.setItem(AS_ENTRY_URL_KEY, fallbackUrl);
  } catch (error) {
    // ignore storage errors
  }

  return fallbackUrl;
}

function initStepHistory() {
  if (!window.history || typeof window.history.pushState !== 'function') return;

  entryUrl = resolveEntryUrl();

  window.addEventListener('popstate', (event) => {
    const nextState = event.state;
    if (!nextState || !nextState.asStep) return;
    const targetStep = normalizeStep(nextState.asStep);

    if (!hasCompleted && targetStep >= 2 && !isStep1ProgressReady()) {
      goToStep(1, { history: 'replace' });
      if (targetStep > currentStep) {
        openAsStepNoticeModal('1단계 제품 선택을 완료한 후 다음 단계로 이동해 주세요.');
      }
      return;
    }

    if (!hasCompleted && targetStep >= 3 && !isStep2ProgressReady()) {
      goToStep(2, { history: 'replace' });
      if (targetStep > currentStep) {
        openAsStepNoticeModal('2단계 필수 항목(부위/증상/상세증상/첨부파일)을 완료한 후 다음 단계로 이동해 주세요.');
      }
      return;
    }

    if (hasCompleted && targetStep < 4) {
      const targetUrl = entryUrl || '/';
      if (targetUrl && targetUrl !== window.location.href) {
        window.location.replace(targetUrl);
      } else {
        goToStep(4, { history: 'replace' });
      }
      return;
    }
    goToStep(targetStep, { history: false });
  });

  const savedState = readAsRefreshState();
  if (shouldRestoreAsRefreshState(savedState)) {
    if (safeString(savedState.entryUrl)) {
      entryUrl = safeString(savedState.entryUrl);
    }

    if (savedState.step === 4) {
      needsAttachFileReuploadNotice = false;
      latestStep4Data = sanitizeStep4DataForRefresh(savedState.step4Data);
      window.history.replaceState({ asStep: 4, asCompleted: true }, '', window.location.href);
      goToStep(4, { history: false });
      setTimeout(() => {
        restoreAsRefreshStateToUI(savedState);
      }, 0);
      return;
    }

    if (savedState.step === 3) {
      Object.assign(formData, savedState.formData || {});
      formData.attach_file = [];
      needsAttachFileReuploadNotice = true;

      // 3단계 새로고침 시 첨부파일이 유실되므로 2단계로 이동시켜 재첨부를 유도한다.
      window.history.replaceState({ asStep: 2, asCompleted: false }, '', window.location.href);
      goToStep(2, { history: false });
      setTimeout(() => {
        restoreAsRefreshStateToUI(savedState);
      }, 0);
      return;
    }

    Object.assign(formData, savedState.formData || {});
    formData.attach_file = [];
    needsAttachFileReuploadNotice = Boolean(savedState.hadAttachFiles);
    window.history.replaceState({ asStep: savedState.step, asCompleted: false }, '', window.location.href);
    goToStep(savedState.step, { history: false });
    setTimeout(() => {
      restoreAsRefreshStateToUI(savedState);
    }, 0);
    return;
  }

  if (isReloadNavigation()) {
    window.history.replaceState({ asStep: 1, asCompleted: false }, '', window.location.href);
    goToStep(1, { history: false });
    needsAttachFileReuploadNotice = false;
    clearAsRefreshState();
    return;
  }

  // 명확히 신규 진입으로 판단되는 경우에만 이전 스냅샷을 제거한다.
  if (shouldClearAsRefreshStateOnEntry(savedState)) {
    clearAsRefreshState();
  }

  const state = window.history.state;
  if (state && state.asCompleted) {
    hasCompleted = true;
  }

  if (state && state.asStep) {
    const targetStep = normalizeStep(state.asStep);
    if (!hasCompleted && targetStep >= 2 && !isStep1ProgressReady()) {
      goToStep(1, { history: 'replace' });
      if (targetStep > currentStep) {
        openAsStepNoticeModal('1단계 제품 선택을 완료한 후 다음 단계로 이동해 주세요.');
      }
      return;
    }

    if (!hasCompleted && targetStep >= 3 && !isStep2ProgressReady()) {
      goToStep(2, { history: 'replace' });
      if (targetStep > currentStep) {
        openAsStepNoticeModal('2단계 필수 항목(부위/증상/상세증상/첨부파일)을 완료한 후 다음 단계로 이동해 주세요.');
      }
      return;
    }

    if (hasCompleted && targetStep < 4) {
      const targetUrl = entryUrl || '/';
      if (targetUrl && targetUrl !== window.location.href) {
        window.location.replace(targetUrl);
      } else {
        goToStep(4, { history: 'replace' });
      }
      return;
    }

    goToStep(targetStep, { history: false });
    return;
  } else {
    window.history.replaceState({ asStep: currentStep, asCompleted: false }, '', window.location.href);
  }
}

// PLUS ZERO: submit_as_request 3 ~ 5 핸들링
function handleSubmitAsRequest(num) {
  if(window.dataLayer) {
    let step_name_text = '';
    if(num === 2) {
      step_name_text = '제품 선택';
    } else if(num === 3) {
      step_name_text = '제품 증상 입력';
    } else if(num === 4) {
      step_name_text = '고객 정보 입력';
    }

    window.dataLayer.push({
      event: 'submit_as_request',
      page_type: 'SUPPORT',
      step_name: step_name_text || '_',
      click_text: '_',
      as_part: '_',
      as_issue_type: '_'
    });
  }
}

// 다음 버튼 이벤트 연결
function initializeNextButtons() {
  const nextButtons = document.querySelectorAll('.as-next-btn');

  nextButtons.forEach(button => {
    button.addEventListener('click', async () => {
      const nextStep = parseInt(button.getAttribute('data-next-step'));

      // 1. 현재 단계 유효성 검사
      const validationResult = validateStep(currentStep);
      if (!validationResult.isValid) { // 실패
        console.error('Validation failed');
        if (validationResult.firstErrorEl) {
          validationResult.firstErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      // 1-1. 1단계 → 2단계 이동 시 시리얼 신청 가능 여부 사전 확인
      if (currentStep === 1 && nextStep === 2) {
        // 1단계는 현재 화면의 선택값을 최우선으로 사용한다.
        const selectedSerial = safeString(document.querySelector('#as-form-1 input[name="selectProduct"]:checked')?.value)
          || safeString(formData.serialNumber);

        if (!selectedSerial) {
          openAsStepNoticeModal('제품을 선택한 뒤 다시 시도해 주세요.');
          return;
        }

        updateFormData('serialNumber', selectedSerial);

        if (isCheckingSerialAvailability) return;

        try {
          isCheckingSerialAvailability = true;
          button.disabled = true;
          if (typeof openLoadingModal === 'function') {
            openLoadingModal();
          }

          const availability = await checkAsSerialAvailability(selectedSerial);
          if (!availability.canProceed) {
            if (availability.isInProgress) {
              openAsSerialInProgressModal();
              return;
            }
            openAsStepNoticeModal(availability.message || '현재 선택한 제품은 AS 신청이 불가능합니다.');
            return;
          }
        } finally {
          if (typeof closeLoadingModal === 'function') {
            closeLoadingModal();
          }
          isCheckingSerialAvailability = false;
          // 비활성 고착 방지: 최종 상태는 checkNextButtonState(1)에서 재판단한다.
          button.disabled = false;
          if (typeof checkNextButtonState === 'function') {
            checkNextButtonState(1);
          }
        }
      }

      // 2. 현재 단계 데이터 저장
      const saveSuccess = saveStepData(currentStep);
      if (!saveSuccess) {
        console.error('Failed to save step data');
        return;
      }

      // 3-1. 3단계에서 4단계로 이동 시 API 호출
      if (currentStep === 3 && nextStep === 4) {
        if (isSubmittingAsRequest) return;

        try {
          isSubmittingAsRequest = true;
          button.disabled = true;

          if (typeof openLoadingModal === 'function') {
            openLoadingModal();
          }

          const response = await submitASApplication(formData);

          const step4Data = buildStep4Data(formData, response);
          latestStep4Data = sanitizeStep4DataForRefresh(step4Data);

          // PLUS ZERO: submit_as_request - 5
          handleSubmitAsRequest(nextStep);

          // PLUS ZERO: submit_as_request - 6
          if(window.dataLayer) {
            window.dataLayer.push({
              event: 'submit_as_request',
              page_type: 'SUPPORT',
              step_name: 'AS 신청 완료',
              click_text: resolveSelectedProductNameFromDom() || '_',
              as_part: step4Data.part || '_',
              as_issue_type: step4Data.symptom || '_'
            });
          }

          goToStep(nextStep, { history: 'replace' });
          renderData(step4Data);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (error) {
          console.error('AS 신청 오류:', error);
          openAsStepNoticeModal(error?.message || 'AS 신청 중 오류가 발생했습니다.');
        } finally {
          if (typeof closeLoadingModal === 'function') {
            closeLoadingModal();
          }
          isSubmittingAsRequest = false;
          // 비활성 고착 방지: 최종 상태는 checkNextButtonState(3)에서 재판단한다.
          button.disabled = false;
          if (typeof checkNextButtonState === 'function') {
            checkNextButtonState(3);
          }
        }
        return;
      }

      // PLUS ZERO: submit_as_request - 3 ~ 4
      handleSubmitAsRequest(nextStep);

      // 3-2. 다른 단계는 기존 로직대로 이동
      if (nextStep >= 1 && nextStep <= 4) {
        goToStep(nextStep, { history: 'push' });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  });
}

// 다음 단계로 이동
function goToStep(stepNumber, options = {}) {
  const safeStep = normalizeStep(stepNumber);
  const historyMode = options.history ?? 'push';

  // 1. 모든 폼 숨기기
  for (let i = 1; i <= 4; i++) {
    const form = document.getElementById(`as-form-${i}`);
    if (form) form.classList.add('hidden');
  }

  // 2. 현재 단계 폼 표시
  const currentForm = document.getElementById(`as-form-${safeStep}`);
  if (currentForm) currentForm.classList.remove('hidden');

  // 3. 진행바 업데이트
  updateProgressBar(safeStep);

  // 4. 현재 단계 업데이트
  currentStep = safeStep;
  if (safeStep === 4) {
    hasCompleted = true;
    clearAsEntryUrl();
  }

  notifyAttachFileReuploadIfNeeded(safeStep);

  if (historyMode !== false && window.history && typeof window.history.pushState === 'function') {
    const nextState = { asStep: safeStep, asCompleted: safeStep === 4 };
    if (historyMode === 'replace') {
      window.history.replaceState(nextState, '', window.location.href);
    } else {
      window.history.pushState(nextState, '', window.location.href);
    }
  }

  persistAsRefreshState();
}

// 진행바 업데이트
function updateProgressBar(stepNumber) {
  for (let i = 1; i <= 4; i++) {
    const stepItem = document.getElementById(`as-step-${i}`);
    if (stepItem) {
      if (i === stepNumber) {
        stepItem.classList.add('active');
      } else {
        stepItem.classList.remove('active');
      }
    }
  }
}

// 단계별 검증 함수 매칭
function validateStep(stepNumber) {
  switch(stepNumber) {
    case 1:
      return validateStep1();
    case 2:
      return validateStep2();
    case 3:
      return validateStep3();
    default:
      return { isValid: true };
  }
}

// 1
function validateStep1() {
  // formData 또는 DOM에서 선택 여부 확인
  const hasSelection = formData.serialNumber ||
    document.querySelector('#as-form-1 input[name="selectProduct"]:checked');

  if (!hasSelection) {
    openAsProductNotSelectedModal();
    return { isValid: false, firstErrorEl: null };
  }

  return { isValid: true, firstErrorEl: null };
}

// 2
function validateStep2() {
  const partSelect = document.querySelector('#as-form-2 .as-symptom .select-part');
  const symptomSelect = document.querySelector('#as-form-2 .as-symptom .select-symptom');
  const textarea = document.querySelector('#as-form-2 .box-text textarea');
  let isValid = true;
  let firstErrorEl = null;
  let hasInvalidCode = false;
  const isCodeLoadFailed =
    partSelect?.dataset?.codeLoadFailed === 'true' ||
    symptomSelect?.dataset?.codeLoadFailed === 'true';

  const clearSelectValidationError = (selectEl) => {
    if (!selectEl) return;
    selectEl.parentElement?.querySelector('.text-error')?.classList.add('hidden');
  };

  // 1. 부위 선택 여부 확인
  if (isCodeLoadFailed) {
    clearSelectValidationError(partSelect);
    clearSelectValidationError(symptomSelect);
    isValid = false;
  } else {
    if (!isAsCommonCode(formData.part)) {
      const errEl = partSelect?.closest('.as-symptom-select')?.querySelector('.text-error');
      if (errEl) errEl.classList.remove('hidden');
      if (!firstErrorEl) firstErrorEl = errEl || partSelect;
      isValid = false;
      hasInvalidCode = true;
    } else {
      partSelect?.closest('.as-symptom-select')?.querySelector('.text-error')?.classList.add('hidden');
    }

    // 2. 증상 선택 여부 확인
    if (!isAsCommonCode(formData.symptom)) {
      const errEl = symptomSelect?.closest('.as-symptom-select')?.querySelector('.text-error');
      if (errEl) errEl.classList.remove('hidden');
      if (!firstErrorEl) firstErrorEl = errEl || symptomSelect;
      isValid = false;
      hasInvalidCode = true;
    } else {
      symptomSelect?.closest('.as-symptom-select')?.querySelector('.text-error')?.classList.add('hidden');
    }
  }

  // 3. 상세 증상 입력 여부 확인
  if (!isStep2SymptomDescValid(formData.symptom_desc)) {
    const errEl = textarea?.parentElement?.querySelector('.text-error');
    if (errEl) errEl.classList.remove('hidden');
    if (!firstErrorEl) firstErrorEl = errEl || textarea;
    isValid = false;
  } else {
    textarea?.parentElement?.querySelector('.text-error')?.classList.add('hidden');
  }

  // 4. 파일 첨부 1장 이상 확인
  if (!formData.attach_file || formData.attach_file.length === 0) {
    const fileNoError = document.querySelector('#as-form-2 .as-step-error-msg.file-no');
    if (fileNoError) fileNoError.classList.remove('hidden');
    if (!firstErrorEl) firstErrorEl = fileNoError;
    isValid = false;
  }

  if (isCodeLoadFailed) {
    openAsStepNoticeModal('부위/증상 코드 정보를 불러오지 못했습니다. 새로고침 후 다시 선택해 주세요.');
  }

  return { isValid, firstErrorEl };
}

// 3
function validateStep3() {
  const form3 = document.querySelector('#as-form-3');
  if (!form3) return { isValid: false, firstErrorEl: null };

  let isValid = true;
  let firstErrorEl = null;

  const showFieldErr = (errId, condition, hideClass = 'hidden') => {
    const errEl = form3.querySelector(errId);
    if (!condition) {
      if (errEl) errEl.classList.remove(hideClass);
      if (!firstErrorEl) firstErrorEl = errEl;
      return false;
    } else {
      if (errEl) errEl.classList.add(hideClass);
      return true;
    }
  };

  // 신청 정보 검증
  const hasApplicantName = getSanitizedAsNameValue(form3, '#applicant_name') !== '';
  const applicantPhone1 = form3.querySelector('#applicant_phone_1')?.value || '';
  const applicantPhone1Validation = validateApplicantPhone1(applicantPhone1);
  const applicantPhone1ErrorEl = form3.querySelector('#applicant_phone_1_error');
  const hasAddressZonecode = form3.querySelector('#address_zonecode')?.value.trim() !== '';
  const hasAddressMain = form3.querySelector('#address_main')?.value.trim() !== '';
  const hasAddressDetailUnknown = form3.querySelector('#address_detail_unknown')?.checked || false;
  const hasAddressDetailInput = form3.querySelector('#address_detail')?.value.trim() !== '';
  const hasAddressDetail = hasAddressDetailUnknown || hasAddressDetailInput;
  const hasConfirmCheckbox = form3.querySelector('#confirm_checkbox')?.checked || false;

  if (!showFieldErr('#applicant_name_error', hasApplicantName)) isValid = false;
  if (!applicantPhone1Validation.isValid) {
    if (applicantPhone1ErrorEl) {
      applicantPhone1ErrorEl.textContent = applicantPhone1Validation.message;
      applicantPhone1ErrorEl.classList.remove('hidden');
    }
    if (!firstErrorEl) firstErrorEl = applicantPhone1ErrorEl;
    isValid = false;
  } else if (applicantPhone1ErrorEl) {
    applicantPhone1ErrorEl.classList.add('hidden');
  }
  if (!showFieldErr('#address_error', hasAddressZonecode && hasAddressMain)) isValid = false;
  if (!showFieldErr('#address_detail_error', hasAddressDetail)) isValid = false;
  if (!showFieldErr('#confirm_checkbox_error', hasConfirmCheckbox)) isValid = false;

  if (SHOW_PURCHASE_INFO) {
    // 구매 정보 검증
    const relationshipValue = form3.querySelector('#applicant_relationship')?.value || '';
    const isDifferent = relationshipValue !== '' && relationshipValue !== '본인';
    const purchaseDateUnknown = form3.querySelector('#purchase_date_unknown')?.checked || false;
    const purchaseChannelUnknown = form3.querySelector('#purchase_channel_unknown')?.checked || false;
    const hasPurchaseDate = purchaseDateUnknown || (form3.querySelector('#purchase_date')?.value.trim() !== '');
    const hasPurchaseChannel = purchaseChannelUnknown || (form3.querySelector('#purchase_channel')?.value.trim() !== '');
    const hasPurchaseChannelDetail = purchaseChannelUnknown || (form3.querySelector('#purchase_channel_detail')?.value.trim() !== '');

    if (!showFieldErr('#purchase_date_error', hasPurchaseDate, 'no-visible')) isValid = false;
    if (!showFieldErr('#purchase_channel_error', hasPurchaseChannel, 'no-visible')) isValid = false;
    if (!showFieldErr('#purchase_channel_detail_error', hasPurchaseChannelDetail)) isValid = false;

    let buyerInfoValid = hasPurchaseDate && hasPurchaseChannel && hasPurchaseChannelDetail;

    if (isDifferent) {
      const buyerNameUnknown = form3.querySelector('#buyer_name_unknown')?.checked || false;
      const hasBuyerName = buyerNameUnknown || (getSanitizedAsNameValue(form3, '#buyer_name') !== '');
      buyerInfoValid = hasBuyerName && buyerInfoValid;
    }

    if (!buyerInfoValid) isValid = false;
  }

  return { isValid, firstErrorEl };
}

// formData 업데이트 함수
function updateFormData(field, value) {
  formData[field] = value;
  persistAsRefreshState();
}

// 단계별 데이터 저장 함수 매칭
function saveStepData(stepNumber) {
  switch(stepNumber) {
    case 1:
      return saveStep1Data();
    case 2:
      return saveStep2Data();
    case 3:
      return saveStep3Data();
    default:
      return true;
  }
}

// 1
function saveStep1Data() {
  const selectedRadio = document.querySelector('input[name="selectProduct"]:checked');
  if (selectedRadio) {
    // Step1은 화면에서 현재 선택된 값을 항상 우선한다.
    updateFormData('serialNumber', safeString(selectedRadio.value));
    return true;
  }

  // DOM 선택값이 없으면 기존 상태를 fallback으로 사용한다.
  if (safeString(formData.serialNumber)) {
    return true;
  }

  console.error('Failed to save Step 1 data: No product selected');
  return false;
}

// 2
function saveStep2Data() {
  // formData에 이미 실시간으로 저장되어 있으므로 검증만 수행
  const partSelect = document.querySelector('#as-form-2 .as-symptom .select-part');
  const symptomSelect = document.querySelector('#as-form-2 .as-symptom .select-symptom');
  const textarea = document.querySelector('#as-form-2 .box-text textarea');

  // DOM 값으로 formData 업데이트
  if (partSelect && partSelect.value) {
    formData.part = partSelect.value;
  }

  if (symptomSelect && symptomSelect.value) {
    formData.symptom = symptomSelect.value;
  }

  if (textarea && textarea.value) {
    formData.symptom_desc = textarea.value;
  }

  return true;
}

// 3
function saveStep3Data() {
  const form3 = document.querySelector('#as-form-3');
  if (!form3) return false;
  const buyerNameInput = form3.querySelector('#buyer_name');
  const applicantNameInput = form3.querySelector('#applicant_name');

  // 구매 정보
  const relVal = form3.querySelector('#applicant_relationship')?.value || '';
  formData.is_different = relVal !== '' && relVal !== '본인';
  formData.buyer_name = sanitizeAsNameInputElement(buyerNameInput);
  formData.buyer_name_unknown = form3.querySelector('#buyer_name_unknown')?.checked || false;
  formData.purchase_date = form3.querySelector('#purchase_date')?.value || '';
  formData.purchase_date_unknown = form3.querySelector('#purchase_date_unknown')?.checked || false;
  formData.purchase_channel = form3.querySelector('#purchase_channel')?.value || '';
  formData.purchase_channel_detail = form3.querySelector('#purchase_channel_detail')?.value || '';
  formData.purchase_channel_unknown = form3.querySelector('#purchase_channel_unknown')?.checked || false;

  // 신청 정보
  formData.applicant_name = sanitizeAsNameInputElement(applicantNameInput);
  formData.applicant_relationship = form3.querySelector('#applicant_relationship')?.value || '';
  formData.applicant_phone_1 = form3.querySelector('#applicant_phone_1')?.value || '';
  formData.applicant_phone_2 = form3.querySelector('#applicant_phone_2')?.value || '';
  formData.address_zonecode = form3.querySelector('#address_zonecode')?.value || '';
  formData.address_main = form3.querySelector('#address_main')?.value || '';
  formData.address_detail_unknown = form3.querySelector('#address_detail_unknown')?.checked || false;
  formData.address_detail = formData.address_detail_unknown
    ? ''
    : (form3.querySelector('#address_detail')?.value || '');
  formData.visit_date = form3.querySelector('#visit_date')?.value || '';
  formData.confirm_checkbox = form3.querySelector('#confirm_checkbox')?.checked || false;

  return true;
}

// 단계별 다음 버튼 활성화/비활성화 체크 (실시간 에러 숨김 처리)
function checkNextButtonState(currentStep) {
  // 2: 조건 충족 시 개별 에러 숨김
  if (currentStep === 2) {
    const partSelect = document.querySelector('#as-form-2 .as-symptom .select-part');
    const symptomSelect = document.querySelector('#as-form-2 .as-symptom .select-symptom');
    const textarea = document.querySelector('#as-form-2 .box-text textarea');

    if (formData.part && formData.part.trim() !== '') {
      partSelect?.closest('.as-symptom-select')?.querySelector('.text-error')?.classList.add('hidden');
    }
    if (formData.symptom && formData.symptom.trim() !== '') {
      symptomSelect?.closest('.as-symptom-select')?.querySelector('.text-error')?.classList.add('hidden');
    }
    if (isStep2SymptomDescValid(formData.symptom_desc)) {
      textarea?.parentElement?.querySelector('.text-error')?.classList.add('hidden');
    }
    if (formData.attach_file && formData.attach_file.length > 0 && formData.attach_file.length < 6) {
      if (typeof hideFileError === 'function') hideFileError();
    }
  }

  // 3: 조건 충족 시 개별 에러 숨김
  if (currentStep === 3) {
    const form3 = document.querySelector('#as-form-3');
    if (!form3) return;

    if (getSanitizedAsNameValue(form3, '#applicant_name') !== '') {
      form3.querySelector('#applicant_name_error')?.classList.add('hidden');
    }
    const applicantPhone1 = form3.querySelector('#applicant_phone_1')?.value || '';
    const applicantPhone1Validation = validateApplicantPhone1(applicantPhone1);
    const applicantPhone1ErrorEl = form3.querySelector('#applicant_phone_1_error');
    if (applicantPhone1Validation.isValid) {
      applicantPhone1ErrorEl?.classList.add('hidden');
    } else if (applicantPhone1ErrorEl && !applicantPhone1ErrorEl.classList.contains('hidden')) {
      applicantPhone1ErrorEl.textContent = applicantPhone1Validation.message;
    }
    const hasAddressZonecode = form3.querySelector('#address_zonecode')?.value.trim() !== '';
    const hasAddressMain = form3.querySelector('#address_main')?.value.trim() !== '';
    const hasAddressDetailUnknown = form3.querySelector('#address_detail_unknown')?.checked || false;
    const hasAddressDetailInput = form3.querySelector('#address_detail')?.value.trim() !== '';
    const hasAddressDetail = hasAddressDetailUnknown || hasAddressDetailInput;
    if (hasAddressZonecode && hasAddressMain) {
      form3.querySelector('#address_error')?.classList.add('hidden');
    }
    if (hasAddressDetail) {
      form3.querySelector('#address_detail_error')?.classList.add('hidden');
    }
    if (form3.querySelector('#confirm_checkbox')?.checked) {
      form3.querySelector('#confirm_checkbox_error')?.classList.add('hidden');
    }
    if (typeof SHOW_PURCHASE_INFO !== 'undefined' && SHOW_PURCHASE_INFO) {
      const purchaseDateUnknown = form3.querySelector('#purchase_date_unknown')?.checked || false;
      const purchaseChannelUnknown = form3.querySelector('#purchase_channel_unknown')?.checked || false;
      const hasPurchaseDate = purchaseDateUnknown || (form3.querySelector('#purchase_date')?.value.trim() !== '');
      const hasPurchaseChannel = purchaseChannelUnknown || (form3.querySelector('#purchase_channel')?.value.trim() !== '');
      const hasPurchaseChannelDetail = purchaseChannelUnknown || (form3.querySelector('#purchase_channel_detail')?.value.trim() !== '');

      if (hasPurchaseDate) form3.querySelector('#purchase_date_error')?.classList.add('no-visible');
      if (hasPurchaseChannel) form3.querySelector('#purchase_channel_error')?.classList.add('no-visible');
      if (hasPurchaseChannelDetail) form3.querySelector('#purchase_channel_detail_error')?.classList.add('hidden');
    }
  }
}

// AS 신청 API 호출 함수
async function submitASApplication(data) {
  const payload = buildAsSubmitPayload(data);
  const requestFormData = new FormData();

  Object.entries(payload.fields).forEach(([key, value]) => {
    requestFormData.append(key, value);
  });

  payload.files.forEach((file) => {
    requestFormData.append('fileList', file);
  });

  let response;
  try {
    response = await fetch(AS_SUBMIT_ENDPOINT, {
      method: 'POST',
      body: requestFormData
    });
  } catch (error) {
    const networkMessage = resolveAsSubmitNetworkErrorMessage(error);
    void logAsSubmitFailure({
      payload,
      apiResponse: JSON.stringify({
        name: safeString(error?.name),
        message: safeString(error?.message)
      }),
      apiMessage: networkMessage,
      apiCode: 'NETWORK'
    });
    throw new Error(networkMessage);
  }

  let responseBody = null;
  let responseText = '';
  try {
    responseText = await response.text();
  } catch (error) {
    responseText = '';
  }

  if (responseText) {
    try {
      responseBody = JSON.parse(responseText);
    } catch (error) {
      responseBody = null;
    }
  }

  if (!response.ok) {
    const errorMessage = resolveAsSubmitErrorMessage(responseBody, response.status);
    void logAsSubmitFailure({
      payload,
      apiResponse: responseText,
      apiMessage: errorMessage,
      apiCode: String(response.status || 500)
    });
    throw new Error(errorMessage);
  }

  if (!isAsSubmitSuccess(responseBody)) {
    const errorCode = parseIntegerOrDefault(responseBody?.code, response.status || -1);
    const errorMessage = resolveAsSubmitErrorMessage(responseBody, response.status);
    void logAsSubmitFailure({
      payload,
      apiResponse: responseText,
      apiMessage: errorMessage,
      apiCode: String(errorCode)
    });
    throw new Error(errorMessage);
  }

  return responseBody || {};
}

function buildAsSubmitLogRequest(payload) {
  const fileList = Array.isArray(payload?.files)
    ? payload.files.map((file) => ({
        name: safeString(file?.name),
        type: safeString(file?.type),
        size: Number(file?.size || 0)
      }))
    : [];

  return JSON.stringify({
    ...(payload?.fields || {}),
    fileList
  });
}

async function logAsSubmitFailure({ payload, apiResponse, apiMessage, apiCode }) {
  try {
    await fetch(API_LOG_ADD_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        apiAddr: '/v2/as/asSaveReqInfo',
        apiRequest: buildAsSubmitLogRequest(payload),
        apiResponse: safeString(apiResponse) || '{result=error}',
        apiMessage: safeString(apiMessage) || 'Unknown error',
        apiCode: safeString(apiCode) || '500'
      })
    });
  } catch (error) {
    console.error('AS 실패 로그 적재 실패:', error);
  }
}

function resolveAsSubmitNetworkErrorMessage(error) {
  const rawMessage = safeString(error?.message).toLowerCase();
  const rawName = safeString(error?.name).toLowerCase();

  if (
    rawMessage.includes('load failed')
    || rawMessage.includes('failed to fetch')
    || rawMessage.includes('networkerror')
    || rawMessage.includes('network request failed')
    || rawName === 'typeerror'
  ) {
    return 'AS 접수 서버와 연결이 원활하지 않습니다. 잠시 후 다시 시도해 주세요.';
  }

  return 'AS 접수 처리 중 일시적인 통신 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
}

// 4 데이터 채우기
function renderData(data) {
  const form4 = document.querySelector('#as-form-4');

  if (!form4) return;
  latestStep4Data = sanitizeStep4DataForRefresh(data);

  // AS 신청 제품 정보
  const productNameEl = form4.querySelector('.product_name');
  const productCodeEl = form4.querySelector('.prodcut_code');
  const colorCodeEl = form4.querySelector('.color_code');
  const serialNumberEl = form4.querySelector('.serialNumber');

  if (productNameEl) productNameEl.textContent = data.product_name || '';
  if (productCodeEl) productCodeEl.textContent = data.prodcut_code || '';
  if (colorCodeEl) colorCodeEl.textContent = data.color_code || '';
  if (serialNumberEl) serialNumberEl.textContent = data.serialNumber || '';

  // 제품 증상
  const partEl = form4.querySelector('.part');
  const symptomEl = form4.querySelector('.symptom');

  if (partEl) partEl.textContent = data.part || '';
  if (symptomEl) symptomEl.textContent = data.symptom || '';

  // 파일 첨부 영역은 완료 화면에서 노출하지 않는다.
  const imageCardEl = form4.querySelector('.as-card.image-card');
  const attachSectionEl = imageCardEl?.closest('.as-complete-info');
  if (attachSectionEl) {
    attachSectionEl.classList.add('hidden');
  } else if (imageCardEl) {
    imageCardEl.classList.add('hidden');
  }

  // 신청 정보
  const applicantNameEl = form4.querySelector('.applicant_name');
  const applicantPhone1El = form4.querySelector('.applicant_phone_1');
  const applicantAddressEl = form4.querySelector('.applicant_address');

  if (applicantNameEl) applicantNameEl.textContent = data.applicant_name || '';
  if (applicantPhone1El) applicantPhone1El.textContent = data.applicant_phone_1 || '';

  // 주소 포맷: (우편번호) 기본 주소 상세 주소
  if (applicantAddressEl) {
    const zonecode = data.address_zonecode || '';
    const mainAddress = data.address_main || '';
    const detailAddress = data.address_detail || '';
    applicantAddressEl.textContent = `(${zonecode}) ${mainAddress} ${detailAddress}`;
  }
}

function buildAsSubmitPayload(data) {
  const customerHash = safeString(typeof customerMd5Hash !== 'undefined' ? customerMd5Hash : '');
  const customerEmail = safeString(
    (typeof window !== 'undefined' && typeof window.customer_email !== 'undefined')
      ? window.customer_email
      : ''
  );
  const ctmId = customerEmail;
  if (!customerHash) {
    throw new Error('로그인 정보가 없습니다. 다시 로그인 후 시도해 주세요.');
  }

  const selectedProduct = resolveSelectedProductBySerial(data.serialNumber);
  const productCd = safeString(selectedProduct?.itmCd);
  const productCol = safeString(selectedProduct?.colCd);
  const serial = safeString(data.serialNumber);
  const productDetailCode = safeString(data.part);
  const productProblemCode = safeString(data.symptom);

  if (!productCd || !productCol || !serial) {
    throw new Error('선택한 제품 정보를 확인할 수 없습니다. 제품을 다시 선택해 주세요.');
  }

  if (!isAsCommonCode(productDetailCode) || !isAsCommonCode(productProblemCode)) {
    throw new Error('부위/증상 코드 정보를 불러오지 못했습니다. 새로고침 후 다시 선택해 주세요.');
  }

  const applicantName = safeString(data.applicant_name);
  const applicantRelationship = safeString(data.applicant_relationship) || '본인';
  const applicantPhone1 = safeString(data.applicant_phone_1);
  const applicantPhone2 = safeString(data.applicant_phone_2) || applicantPhone1;
  const addressDetail = resolveAddressDetailForSubmit(data);
  const visitDt = normalizeYmd(data.visit_date);
  const buyDt = resolveBuyDt(data);
  const buyNm = resolveBuyNm(data, applicantName);
  const buyHp = applicantPhone1;

  const fields = {
    customerMd5Hash: customerHash,
    ctmId,
    productCd,
    productCol,
    serial,
    productDetail: productDetailCode,
    productProblem: productProblemCode,
    productProblemDesc: safeString(data.symptom_desc),
    ctmNm: applicantName,
    rlToBuy: applicantRelationship,
    ctmHp: applicantPhone1,
    ctmTel: applicantPhone2,
    visitDt,
    ctmZip: safeString(data.address_zonecode),
    ctmAddr: safeString(data.address_main),
    ctmAddrDetail: addressDetail,
    buyLoc: mapBuyLoc(data.purchase_channel, data.purchase_channel_unknown),
    buyVndTxt: resolveBuyVndTxt(data),
    buyDt,
    buyNm,
    buyHp,
  };

  const missingFields = Object.entries(fields)
    .filter(([key, value]) => key !== 'visitDt' && !safeString(value))
    .map(([key]) => key);

  if (missingFields.length > 0) {
    throw new Error(`필수 입력값이 누락되었습니다: ${missingFields.join(', ')}`);
  }

  const files = Array.isArray(data.attach_file)
    ? data.attach_file.filter((file) => file instanceof File)
    : [];

  if (files.length === 0) {
    throw new Error('증상 사진/영상 파일을 1개 이상 첨부해 주세요.');
  }

  return { fields, files };
}

function resolveAddressDetailForSubmit(data) {
  if (Boolean(data?.address_detail_unknown)) {
    return '상세 주소 없음';
  }

  return safeString(data?.address_detail);
}

function resolveSelectedProductBySerial(serialNumber) {
  const serial = safeString(serialNumber);
  if (!serial) return null;

  if (typeof registeredProductData !== 'undefined' && Array.isArray(registeredProductData)) {
    return registeredProductData.find((item) => safeString(item?.serialNumber) === serial) || null;
  }

  return null;
}

function resolveBuyNm(data, fallbackName) {
  const isDifferent = Boolean(data?.is_different);
  const buyerUnknown = Boolean(data?.buyer_name_unknown);
  const buyerName = safeString(data?.buyer_name);

  if (!isDifferent) return fallbackName || buyerName || '확인불가';
  if (buyerUnknown) return '확인불가';
  return buyerName || fallbackName || '확인불가';
}

function resolveBuyVndTxt(data) {
  const channelUnknown = Boolean(data?.purchase_channel_unknown);
  if (channelUnknown) return '미입력';

  return safeString(data?.purchase_channel_detail)
    || safeString(data?.purchase_channel)
    || '미입력';
}

function resolveBuyDt(data) {
  const purchaseDateUnknown = Boolean(data?.purchase_date_unknown);
  if (purchaseDateUnknown) return '미입력';

  const ymd = normalizeYmd(data?.purchase_date);
  return ymd || '미입력';
}

function mapBuyLoc(channel, channelUnknown) {
  if (channelUnknown) return '미입력';

  const normalized = safeString(channel);
  if (normalized === '오프라인' || normalized === '매장' || normalized.toUpperCase() === 'OFF') return '오프라인';
  if (normalized === '온라인' || normalized.toUpperCase() === 'ON') return '온라인';
  return '미입력';
}

function normalizeYmd(dateText) {
  const value = safeString(dateText);
  if (!value) return '';

  if (/^\d{8}$/.test(value)) return value;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value.replace(/-/g, '');
  return '';
}

function resolveAttachmentPreviewUrl(fileItem) {
  if (!fileItem) return '';
  if (typeof fileItem === 'string') return fileItem;
  if (fileItem instanceof File) return URL.createObjectURL(fileItem);
  if (typeof fileItem === 'object') {
    return safeString(fileItem.fileUrl) || safeString(fileItem.link);
  }
  return '';
}

function buildStep4Data(submitData, apiResponse) {
  const selectedProduct = resolveSelectedProductBySerial(submitData.serialNumber) || {};
  const partName = safeString(submitData.part_name)
    || resolveSelectOptionText('#as-form-2 .select-part', submitData.part)
    || safeString(submitData.part);
  const symptomName = safeString(submitData.symptom_name)
    || resolveSelectOptionText('#as-form-2 .select-symptom', submitData.symptom)
    || safeString(submitData.symptom);

  const productName =
    safeString(selectedProduct.productFullName)
    || resolveSelectedProductNameFromDom()
    || '';

  return {
    rptNo: safeString(apiResponse?.data?.rptNo),
    product_name: productName,
    prodcut_code: safeString(selectedProduct.itmCd),
    color_code: safeString(selectedProduct.colCd),
    serialNumber: safeString(submitData.serialNumber),
    part: partName,
    symptom: symptomName,
    attach_file: Array.isArray(submitData.attach_file) ? submitData.attach_file : [],
    applicant_name: safeString(submitData.applicant_name),
    applicant_phone_1: safeString(submitData.applicant_phone_1),
    address_zonecode: safeString(submitData.address_zonecode),
    address_main: safeString(submitData.address_main),
    address_detail: resolveAddressDetailForSubmit(submitData),
    visit_date: formatDisplayDate(submitData.visit_date),
  };
}

function resolveSelectedProductNameFromDom() {
  const selectedRadio = document.querySelector('#as-form-1 input[name="selectProduct"]:checked');
  const card = selectedRadio?.closest('.wrap__my_product');
  if (!card) return '';

  const pcTitle = safeString(card.querySelector('.pc_product_title')?.textContent);
  if (pcTitle) return pcTitle;

  return safeString(card.querySelector('.mobile_product_title')?.textContent);
}

function resolveSelectOptionText(selector, value) {
  const select = document.querySelector(selector);
  if (!select) return '';
  const match = Array.from(select.options || []).find((option) => option.value === value);
  return safeString(match?.textContent);
}

function formatDisplayDate(dateText) {
  const ymd = normalizeYmd(dateText);
  if (!ymd) return safeString(dateText);
  return `${ymd.slice(0, 4)}-${ymd.slice(4, 6)}-${ymd.slice(6, 8)}`;
}

function safeString(value) {
  return value === null || value === undefined ? '' : String(value).trim();
}

function parseIntegerOrDefault(value, fallback = -1) {
  const parsed = parseInt(String(value), 10);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function resolveAsSubmitErrorMessage(responseBody, httpStatus) {
  const code = parseIntegerOrDefault(responseBody?.code, -1);
  const rawMsg = safeString(responseBody?.msg);

  // shopify_api(/v2/as/asSaveReqInfo) 코드/메시지 기준 사용자 노출 문구 매핑
  if (code === 1001 || rawMsg.includes('회원정보가 누락되었습니다') || rawMsg.includes('조회된 결과가 없습니다')) {
    return '회원 정보를 확인할 수 없습니다. 다시 로그인 후 시도해 주세요.';
  }

  if (rawMsg.includes('Missing required parameter: fileList')) {
    return '증상 사진/영상 파일을 1개 이상 첨부해 주세요.';
  }

  if (rawMsg.includes('Failed to process upload files')) {
    return '첨부파일 처리 중 오류가 발생했습니다. 파일을 다시 첨부해 주세요.';
  }

  if (rawMsg.includes('ERP API response is empty')) {
    return 'AS 접수 처리 중 일시적인 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
  }

  if (code === 400 || rawMsg.includes('Missing required parameters')) {
    return '입력한 AS 신청 정보를 다시 확인해 주세요.';
  }

  if (code === -1) {
    return 'AS 접수 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
  }

  if (httpStatus === 401 || httpStatus === 403) {
    return '로그인 상태를 확인할 수 없습니다. 다시 로그인 후 시도해 주세요.';
  }

  if (httpStatus === 400) {
    return '입력한 AS 신청 정보를 다시 확인해 주세요.';
  }

  if (typeof httpStatus === 'number' && httpStatus >= 500) {
    return 'AS 접수 처리 중 일시적인 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
  }

  if (rawMsg) {
    return rawMsg;
  }

  return 'AS 신청 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
}

function escapeHtml(value) {
  return safeString(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function isAsSubmitSuccess(response) {
  if (!response) return false;
  const success = response.success === true || String(response.success).toLowerCase() === 'true';
  const code = String(response.code);
  return success && code === '0';
}
